(function ($, Cobalt, undefined) {
    Cobalt.LocalizationEditor = {
        adminLocalizationPhraseEditRoute: null,
        adminLocalizationIndexRoute: null,
        initialize: function () {
            var localizationEditorEnabled = false;
            var toggleId = "#localizationToggle";
            $(Cobalt.LocalizationEditor.toggleId).click(function (cl) {
                Cobalt.LocalizationEditor.localizationEditorEnabled = !Cobalt.LocalizationEditor.localizationEditorEnabled;
                Cobalt.LocalizationEditor.toggleInPlaceEditor(Cobalt.LocalizationEditor.localizationEditorEnabled);
                if (Cobalt.LocalizationEditor.localizationEditorEnabled) {
                    $(this).addClass("enabled");
                } else {
                    $(this).removeClass("enabled");
                }
            });
            // dropdowns in admin pages
            var nsList = $('#namespaceList');
            $('.namespaceSelector').hover(function () {
                nsList.stop(true, true).slideDown(100);
            }, function () {
                nsList.stop(true, true).slideUp(100);
            });

            var snsList = $('#subNamespaceList');
            $('.subNamespaceSelector').hover(function () {
                snsList.stop(true, true).slideDown(100);
            }, function () {
                snsList.stop(true, true).slideUp(100);
            });
        },
        toggleInPlaceEditor: function (enable) {
            if (enable) {
                $('.trans').addClass('hover');
                $('.trans:not(.todo)').attr('title', 'Click to edit');
                $('.trans:not(.todo)').click(function () {
                    return Cobalt.LocalizationEditor.clickToEdit($(this));
                });
                $('.trans.todo').attr('title', 'Search for text');
                $('.trans.todo').click(function () {
                    return Cobalt.LocalizationEditor.clickToSearch($(this));
                });
            } else {
                $('.trans').removeClass('hover');
                $('.trans').unbind('click');
            }
        },
        clickToEdit: function (element) {
            var phraseId = element.attr("data-phrase-id");
            if (phraseId) {
                window.location = Cobalt.LocalizationEditor.adminLocalizationPhraseEditRoute(phraseId);
                return false;
            }
        },
        clickToSearch: function (element) {
            var query = element.html();
            if (query) {
                window.location = Cobalt.LocalizationEditor.adminLocalizationIndexRoute() + "?search=" + escape(query);
                return false;
            }
        }
    };
} (jQuery, Cobalt));


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.LocalizationEditor.js